import dashboard from "./fdashboard";
import services from "./services";
import settings from "./settings";

// ==============================|| MENU ITEMS ||============================== //

const allMenuItems = {
  items: [dashboard, services, settings]
};

// // Check user type and modify allMenuItems accordingly
// if (user && usertype === "admin") {
//   // If user type is admin, include additional menu items
//   allMenuItems.items.push(admin);
// } else if (user && usertype === "CLIENT") {
//   // If user type is client, include additional menu items
//   allMenuItems.items.push(dashboard);
//   allMenuItems.items.push(services);
//   allMenuItems.items.push(settings);
// }

export default allMenuItems;
